const vaccineIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/services/vacina.svg';
const stethoscopeIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/services/estetoscopio.svg';
const apsIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/services/aps.svg';
const examIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/services/exam.svg';
const saudeOcupacionalIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/services/saude_ocupacional.svg';
const checkupIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/check-up-service.svg';

export const PRODUCT_CATEGORY_ICON: {
  [key: string]: {
    alt: string;
    icon: string;
  };
} = {
  APPOINTMENT: { alt: 'Consulta', icon: stethoscopeIcon },
  EXAM: { alt: 'Exame', icon: examIcon },
  IMMUNIZATION: { alt: 'Imunização', icon: vaccineIcon }
};

export const SERVICE_ICONS: { [key: string]: string } = {
  'Atenção Primária à Saúde Clinicas': apsIcon,
  Imunização: vaccineIcon,
  'Médicos Einstein': stethoscopeIcon,
  'PCR Covid-19': examIcon,
  'Saúde Ocupacional': saudeOcupacionalIcon,
  'Check-up digital': checkupIcon,
  DEFAULT: stethoscopeIcon
};

export const serviceIconsList = [
  { name: 'equipe do cuidado', icon: apsIcon },
  { name: 'imunização', icon: vaccineIcon },
  { name: 'médicos', icon: stethoscopeIcon },
  { name: 'pcr', icon: examIcon },
  { name: 'atenção primária', icon: apsIcon },
  { name: 'ocupacional', icon: saudeOcupacionalIcon },
  { name: 'trabalho', icon: saudeOcupacionalIcon },
  { name: 'check-up digital', icon: checkupIcon },
  { name: 'check-up executivo', icon: checkupIcon },
  { name: 'sangue', icon: apsIcon }
];
